import Loadable from '../../../components/loadable';

const ContactWorkouts = Loadable({
  loader: () => import('../../../pages/contacts/workouts'),
  type: 'block',
});

angular.module('gym').value('ContactWorkouts', ContactWorkouts);
